import { PvzOperation } from '@/types/IPvzOperations';

/**
 * Сериализует набор операций ПВЗ в строку кодов через запятую —
 * формат, который ожидает бэкенд (например `'2,3'`).
 */
export const serializePvzOperations = (operations: PvzOperation[]): string =>
  operations.join(',');

/**
 * Дефолтный набор операций ПВЗ для запроса getPVZListV2.
 * Значение представлено строкой кодов через запятую — формат, который
 * ожидает бэкенд.
 */
export const DEFAULT_PVZ_AVAILABLE_OPERATIONS = serializePvzOperations([
  PvzOperation.Issuance,
  PvzOperation.AcceptanceAndIssuance
]);
